export function hasStatus(value: unknown): value is { status: unknown } {
  return typeof value === "object" && value !== null && "status" in value;
}
